import React, { useState } from "react";
import { FaPhone} from "react-icons/fa";
import {activatorUserAdding} from "../../auth";
import PhoneInput, { parsePhoneNumber, formatPhoneNumber, formatPhoneNumberIntl, isValidPhoneNumber, getCountryCallingCode  } from 'react-phone-number-input'
import en from 'react-phone-number-input/locale/en.json'
import 'react-phone-number-input/style.css'
import { elakayAutoText } from "../../pageInside/dataElakay";


const AddtelephoneUserAssociate = (props) => {
    const {
        setPagesUser,
        bnAddAdress,
        setUserInfo,
        token,
        infoSource
            } = props

    const [value, setValue] = useState()
    // Real bug fixes: this used to have no loading/double-click guard at
    // all, AND swallowed a failed request completely silently
    // (`if (data.error) { }` -- empty block, no feedback, no retry path).
    const [submitting, setSubmitting] = useState(false)
    const [error, setError] = useState("")

    const canSubmit = value && isValidPhoneNumber(value) && !submitting

    const clickSubmit = event => {
        event.preventDefault();
        if (!canSubmit) return; // double-click guard (spec §8/§22, TEST 8)
        const data = { "country": en[parsePhoneNumber(value).country], "abrCountry": parsePhoneNumber(value).country, "ariaCode": getCountryCallingCode(parsePhoneNumber(value).country) , "National": formatPhoneNumber(value), "International": formatPhoneNumberIntl(value)}
        setSubmitting(true)
        setError("")
        activatorUserAdding(token, 'telephone', data, true).then(data => {
            if (data.error) {
                // Keep the modal/section open and the typed number intact so
                // the user can fix and retry (spec §13: never fail silently).
                setSubmitting(false)
                setError(data.error)
            } else {
                setSubmitting(false)
                setValue("")
                setPagesUser(bnAddAdress)
                setUserInfo(data)
            }
        });
    };

    const TelephoneButton =()=>(
        <div className="uart-phone-actions">
            <button
                type="button"
                className={`btn uart-btn uart-phone-submit${!canSubmit ? " disabled" : ""}`}
                onClick={clickSubmit}
                disabled={!canSubmit}
            >
                <span className="uart-btn-icon">{submitting ? <span className="uart-spin" aria-hidden="true">⟳</span> : <FaPhone />}</span>
                {submitting ? elakayAutoText("h_uart_saving", "Saving…") : infoSource.laguangeElakay('Button', infoSource.languageAPI).addPhone}
            </button>
        </div>
    )



    const telephoneuser =()=>(
    <div>
        {

            <PhoneInput
                className="uart-phone-input"
                countrySelectProps={{ unicodeFlags: true }}
                placeholder={infoSource.laguangeElakay('label', infoSource.languageAPI).enterPhoneNumber}
                value={value}
                onChange={(next) => { setValue(next); if (error) setError(""); }}
            />

        }
        {value && !isValidPhoneNumber(value) && (
            <p className="uart-field-error">{elakayAutoText("h_uart_invalidPhone", "Please enter a valid phone number.")}</p>
        )}
    </div>
    )



    return   <div className="row mt-4 mb-4 justify-content-center uart-phone-step">
            <div className="col col-12 col-md-10 col-lg-8 col-xl-6 p-0 uart-inline-panel" >
                <div className="col col-12 col-md-12 uart-inline-panel-header">
                    <h4>{infoSource.laguangeElakay('title', infoSource.languageAPI).addPhoneNumber}</h4>
                </div>
         <div className="m-4 uart-phone-field">
       {telephoneuser()}
       {error && <div className="uart-alert uart-alert-danger" role="alert">{error}</div>}
       </div>
                {TelephoneButton()}
         </div>
        </div>


};

export default AddtelephoneUserAssociate;
